import { Directive } from '@angular/core';

@Directive( {
    //   selector: '[ridangoLabel]'
    // tslint:disable-next-line:directive-selector
    selector: 'ridango-label'
} )
export class LabelDirective {

    constructor() { }

}
